import { ExtendedRoute } from '../../../common/src/lib/extended.route';

export class AppNavigationConfig {
  routes!: ExtendedRoute[];
}
